// Utility function to validate and clean document values
export const validateDocumentValue = (value) => {
  // Return null if value is undefined, null, NaN, or string 'undefined'
  if (
    value === undefined || 
    value === null || 
    value === 'undefined' || 
    value === 'null' ||
    (typeof value === 'number' && isNaN(value)) ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'string' && value === 'NaN')
  ) {
    return null;
  }
  
  // Return the value if it's valid
  return value;
};

// Helper to check if a document exists and is valid
export const hasValidDocument = (documents, documentType) => {
  if (!documents || typeof documents !== 'object') {
    return false;
  }
  
  const doc = documents[documentType];
  return validateDocumentValue(doc) !== null;
};

// Helper to get document value safely
export const getDocumentValue = (documents, documentType) => {
  if (!documents || typeof documents !== 'object') {
    return null;
  }
  
  return validateDocumentValue(documents[documentType]);
};
